<template>
  <div>
    <div class="parent">
      <v-card>
        <v-card-title class="info-title" @click="$emit('clicked', index)">
          <font-awesome-icon
            class="collapse"
            :icon="selected ? 'angle-down' : 'angle-left'"
          />
          <div class="text-center text-padding">
            {{ item.Reshte }}
          </div>
        </v-card-title>
        <div>
          <app-row
            icon="building"
            title="مدرسه برگزار کننده آزمون"
            :value="item.School"
          />
          <app-row
            :icon="['far', 'chart-bar']"
            title="نوع آزمون"
            :value="item.StrKExam"
          />
          <app-row icon="calendar-alt" title="تاریخ" :value="item.DDate" />
          <app-row icon="clock" title="زمان" :value="item.DTime" />
          <app-row
            icon="building"
            title="مكان/ لينك مجازي"
            :value="item.Place"
          />
        </div>
        <div v-if="selected">
          <div style="padding: 15px">
            <v-row align="center">
              <v-col class="d-flex">
                <b>توضیحات :</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="content">
                <span v-html="item.Comment"></span>
              </v-col>
            </v-row>

            <v-row align="center">
              <v-col class="d-flex">
                <b>مشاهده نتایج ارزیابی:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex content">
                <div>
                  <b> ارزیابی اول: </b>
                  <div class="indent">
                    <br />
                    <template v-if="item.Arzyab1 != ''">
                      <!-- <b>نام استاد:</b>
                      {{ item.Arzyab1 }} -->
                      <a @click="$emit('showArzyabi', item.Form1Serial)">
                        نتایج ارزیابی
                      </a>
                      {{ item.Emtiaz1 }}
                    </template>
                    <template v-else> ---- </template>
                    <br />
                  </div>
                  <br />
                  <b> ارزیابی دوم: </b>
                  <div class="indent">
                    <br />
                    <template v-if="item.Arzyab2 != ''">
                      <!-- <b>نام استاد:</b>
                      {{ item.Arzyab2 }} -->
                      <a @click="$emit('showArzyabi', item.Form2Serial)">
                        نتایج ارزیابی
                      </a>
                      {{ item.Emtiaz2 }}
                    </template>
                    <template v-else> ---- </template>
                    <br />
                  </div>
                  <br />
                  <b> ارزیابی سوم: </b>
                  <div class="indent">
                    <br />
                    <template v-if="item.Arzyab3 != ''">
                      <!-- <b>نام استاد:</b>
                      {{ item.Arzyab3 }} -->
                      <a @click="$emit('showArzyabi', item.Form3Serial)">
                        نتایج ارزیابی
                      </a>
                      {{ item.Emtiaz3 }}
                    </template>
                    <template v-else> ---- </template>
                    <br />
                  </div>
                </div>
              </v-col>
            </v-row>

            <v-row align="center">
              <v-col class="d-flex">
                <b>نظر مسئول آموزش مدرسه برگزارکننده:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex content">
                {{ item.StrState }}
              </v-col>
            </v-row>
           
            <v-row v-if="item.HasFile" class="ltr">
              <a
                class="innerLink"
                @click="$emit('callDownload', item.Fserial, item.HashToken)"
                ><b>دانلود صوت آزمون شفاهي</b></a
              >
              <br />
            </v-row>
           
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  props: ["item", "index", "selectedItem"],
  computed: {
    selected() {
      return this.selectedItem == this.index;
    },
    dateRange() {
      return "از " + this.item.AzTarikh + " تا " + this.item.TaTarikh;
    },
  },
  components: {
    appRow: DetailRow,
  },
};
</script>
<style scoped>
.register {
  margin: 20px 20px 0 20px !important;
}
.indent {
  margin-right: 30px;
}
.innerLink {
  margin: 16px;
}
</style>
